export const environment = {
	production: false,
	ENABLE_MONITORING: true,
	COGNITO_USER_POOL_ID: "eu-west-2_Ot2OsT6jk",
	COGNITO_CLIENT_APP_ID: "51ci910i63e451shr52fq7jue",
	CLIENT_ENVIRONMENT: "staging",
	API_URL: "https://api.signaloid.dev",
	DOCS_URL: "https://docs.signaloid.dev",
	ALGOLIA_APP_ID: "RDZ73TUYVN",
	ALGOLIA_SEARCH_API_KEY: "9d22873e02ae308211a16ee9f1042d6d",
	ALGOLIA_INDEX_NAME: "signaloid",
	POSTHOG_API_KEY: "phc_jA2Hd2PclQWBnYLvK5nCIvi7R9k121JQDWiKdjvXzkV",
	POSTHOG_API_HOST: "https://eu.i.posthog.com",
	REALTIME_ENDPOINT: "wss://nv2xkupxazc53l6m43tutkhvnm.appsync-realtime-api.eu-west-2.amazonaws.com/event/realtime",
	REALTIME_HOST: "nv2xkupxazc53l6m43tutkhvnm.appsync-api.eu-west-2.amazonaws.com",
	AUTH_FREE_REALTIME_ENDPOINT: "wss://public.realtime.signaloid.dev/event/realtime",
	AUTH_FREE_REALTIME_HOST: "public.realtime.signaloid.dev",
	BROWN_AND_HAM_AUTH_FREE_BUILD_ID: "bld_9fe08f1ef49946e9a1091d432440b224",
	BME680_AUTH_FREE_BUILD_ID: "bld_3601d0008a4543fb9041219c63025f1d",
	IRA_AUTH_FREE_BUILD_ID: "bld_694523919ab249dead4945f3ed1b6d99",
	MOONFIRE_AUTH_FREE_BUILD_ID: "bld_22de76122454451f824f674fc120fd9d",
	BATTERY_STATE_AUTH_FREE_BUILD_ID: "bld_4fbc382b0add4e78a3fb49ffce1fbe07",
	VAR_APP_AUTH_FREE_BUILD_ID: "bld_f26b61e2919d4f03bf7544d82d3a73b2",
	MLX_APP_AUTH_FREE_BUILD_ID: "bld_a8c1d88d07f74efbaf3117712df9a133",
};
